// extracted by mini-css-extract-plugin
export default {"header":"ConsultationCard_header__IEyjs","appealInf":"ConsultationCard_appealInf__ZOOK8","line":"ConsultationCard_line__UNCn7","status":"ConsultationCard_status__ysDGo"};